import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import raahMark from '../assets/raah-mark.png';

export function Landing() {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

  if (isLoading) return null;
  if (isAuthenticated) return <Navigate to="/dashboard" replace />;

  return (
    <div className="landing">
      <div className="landing-card">
        <img src={raahMark} alt="" className="brand-mark" />
        <h1>WATT</h1>
        <p>Web Access Tracking Terminal</p>
        <button className="btn btn-primary" onClick={() => loginWithRedirect()}>
          Log in
        </button>
      </div>
    </div>
  );
}
